import Button from '@/common/components/base/button/Button';
import LoadingButton from '@/common/components/base/button/loadingButton';
import VehiclePlateInput from '@/common/components/base/input/plate/vehiclePlateInput/VehiclePlateInput';
import { VehiclePlateEmptyRules } from '@/common/components/base/input/plate/vehiclePlateInput/vehiclePlateInput.rules';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import { InquiryFormType } from '@/common/components/base/inquiryPlate/forms/InquiryForm.type';
import { InquiryWithPlateFormType } from '@/common/components/base/inquiryPlate/modals/InquiryWithPlateModal.type';
import { InquiryPlateResultType } from '@/common/queries/inquiryPlate/inquiryPlateQuery.type';
import { InquiryPlateQueryOption } from '@/common/queries/inquiryPlate/inquiryPlateQueryOption';
import { NATIONAL_CODE_RULE } from '@/common/utils/rules/nationalCode.rules';
import { requiredText } from '@/common/utils/rules/publicRules';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const InquiryForm = ({
  id,
  onCloseModal,
  onFetchedInquiredPlate,
}: InquiryFormType) => {
  const methods = useForm<InquiryWithPlateFormType>({
    mode: 'onSubmit',
  });
  const { mutate, isPending } = useMutation(InquiryPlateQueryOption());

  const onSubmit = () => {
    mutate(
      {
        id: id as string,
        nationalCode: methods.getValues('nationalCode'),
        plate: methods.getValues('plate').plateString,
      },
      {
        onSuccess: (data) => {
          if (Object.hasOwnProperty.call(data, 'data')) {
            methods.setError('nationalCode', {
              message: (data as AxiosResponse<string, string>).data,
            });

            return;
          }
          onFetchedInquiredPlate?.(data as InquiryPlateResultType);
        },
      },
    );
  };
  const closeModal = () => {
    onCloseModal();
  };
  return (
    <FormProvider {...methods}>
      <Box
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: '2rem',
          justifyContent: 'space-between',
          mb: '10px',
        })}
      >
        <Controller
          name="plate"
          rules={{
            validate: VehiclePlateEmptyRules,
          }}
          render={({ field, fieldState }) => {
            return (
              <VehiclePlateInput
                onChange={(v) => {
                  field.onChange(v);
                  if (methods.formState.touchedFields.plate) {
                    methods.trigger('plate');
                  }
                  methods.setValue('plate', v);
                }}
                value={field.value}
                requiredError={fieldState.error?.message}
              />
            );
          }}
        />

        <TextInput
          direction="rtl"
          name="nationalCode"
          label="کد ملی"
          noCharInput
          placeholder="کد ملی را وارد کنید"
          rules={{
            ...NATIONAL_CODE_RULE,
            required: { message: requiredText, value: true },
          }}
        />

        <Box
          width="100%"
          display="flex"
          justifyContent="space-between"
          gap="10px"
        >
          <Button
            type="reset"
            onClick={closeModal}
            variant="outlined"
            color="common"
            width="50%"
          >
            بازگشت
          </Button>

          <Button
            disabled={!methods.formState.isValid || isPending}
            width="50%"
            type="submit"
            onClick={methods.handleSubmit(onSubmit)}
          >
            {isPending ? null : 'تایید'}
            {isPending ? <LoadingButton loading={isPending} /> : null}
          </Button>
        </Box>
      </Box>
    </FormProvider>
  );
};
export default InquiryForm;
